import React, { useState } from "react";

// interface SearchBarProps {
//   placeholder: string;
// }

const SearchBar = ({ placeholder = "", vlaue }) => {
  const [searchValue, setSearchValue] = useState("");

  const handleSearchClick = () => {
    console.log("Search button clicked with value:", searchValue);
    // Implement your search functionality here
  }; 

  const handleClearClick = () => {
    setSearchValue("");   
  };

  return (
    <div className="col-sm-auto searchBar">
      <span
        className="bx bx-search-alt-2"
        // onClick={handleSearchClick}
      >
      </span>
      <input
        className="form-control"
        type="text"
        placeholder={placeholder}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
      />
      {searchValue && (
        <>
        {/* <span
          className="icon-close"
          onClick={handleClearClick}
        >
        </span> */}
        <button className="btn-close" onClick={handleClearClick}></button>
        </>
      )}
    </div>
  );
};

export default SearchBar;
